import React from 'react';
import {
  findHighlightRanges,
  buildMatchPresentation,
  formatMatchHint,
  extractHighlightTerms,
  normalizeForMatch,
  fieldMatchesSearch,
} from './searchResultHighlightCore';

const HIGHLIGHT_MARK_CLASS = 'search-highlight font-bold text-gray-900 bg-yellow-50';

const highlightText = (text, terms, options = {}) => {
  if (!text) return text;
  if (!terms?.length) return text;

  const stringText = String(text);
  const ranges = findHighlightRanges(stringText, terms, options);
  if (ranges.length === 0) return stringText;

  const nodes = [];
  let cursor = 0;

  ranges.forEach((range, index) => {
    if (range.start > cursor) {
      nodes.push(stringText.slice(cursor, range.start));
    }
    nodes.push(
      <span key={`hl-${index}-${range.start}`} className={HIGHLIGHT_MARK_CLASS}>
        {stringText.slice(range.start, range.end)}
      </span>
    );
    cursor = range.end;
  });

  if (cursor < stringText.length) {
    nodes.push(stringText.slice(cursor));
  }

  return <span className="inline">{nodes}</span>;
};

const highlightSlot = (text, slotTerms, slot, options = {}) => {
  if (!text) return text;

  const { searchTerms, ...highlightOptions } = options;
  const slotHighlightTerms = slotTerms?.[slot];
  const termsToUse =
    slotHighlightTerms?.length > 0
      ? slotHighlightTerms
      : searchTerms?.length > 0
        ? searchTerms
        : null;

  if (!termsToUse?.length) return text;

  const highlighted = highlightText(text, termsToUse, highlightOptions);
  if (highlighted !== text) return highlighted;

  if (
    slotHighlightTerms?.length &&
    searchTerms?.length &&
    searchTerms.some((term) => !slotHighlightTerms.includes(term))
  ) {
    const retryHighlighted = highlightText(text, searchTerms, highlightOptions);
    if (retryHighlighted !== text) return retryHighlighted;
  }

  return text;
};

export {
  extractHighlightTerms,
  normalizeForMatch,
  fieldMatchesSearch,
  findHighlightRanges,
  highlightText,
  highlightSlot,
  buildMatchPresentation,
  formatMatchHint,
};
